import React from 'react';
import { FavouriteIcon } from '@pushpay/iconography';
import { clsx, createUseStyles } from '@pushpay/styles';
import { Button } from './button';
const useStyles = createUseStyles(theme => ({
  root: {
    flex: `0 0 auto`,
    display: 'flex',
    padding: theme.SPACING.FIELD_PADDING,
    margin: 0,
    border: `${theme.SPACING.FIELD_BORDER_WIDTH} solid ${theme.colors['color-border-surface']}`,
    borderRadius: theme.SHAPE.ROUNDED_CORNERS,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    '&:hover, &:focus': {
      color: theme.colors['palette-green'],
      borderColor: theme.colors['palette-green']
    }
  },
  isFavourite: {
    color: theme.colors['palette-white'],
    backgroundColor: theme.colors['palette-green'],
    borderColor: theme.colors['palette-green'],
    '&:hover': {
      color: theme.colors['palette-white'],
      borderColor: theme.colors['palette-green']
    },
    '&:focus': {
      color: theme.colors['palette-white'],
      borderColor: theme.colors['palette-green-dark-300']
    }
  },
  invalid: {
    color: theme.colors['color-text-error'],
    borderColor: theme.colors['color-border-error'],
    '&:hover': {
      borderColor: theme.colors['color-border-error-hover']
    },
    '&:focus': {
      borderColor: theme.colors['color-border-error-focus']
    }
  }
}));
export const FavouriteButton = props => {
  const {
    isFavourite,
    invalid,
    onClick,
    className: classNameProp,
    classes: classesProp,
    'data-pp-at-target': target,
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    onClick: e => {
      if (!isFavourite) {
        onClick(e);
      }
    },
    type: "button",
    classes: {
      root: clsx(classes.root, {
        [classes.isFavourite]: isFavourite,
        [classes.invalid]: invalid
      }, classNameProp)
    },
    "data-pp-at-target": `${target}-button`
  }, rest), /*#__PURE__*/React.createElement(FavouriteIcon, {
    "data-pp-at-target": `${target}-button-icon`
  }));
};
export default FavouriteButton;